export const config ={
    // api : "http://localhost:6002"
    api : "https://vno-portfolio-backend.onrender.com"
}